import { useQuery, useQueryClient } from "@tanstack/react-query";

import { useContentHostId, useThumbnailsApi } from "../../backend/index.ts";
// Specific import: the l10n barrel includes components that would create an import cycle
// for consumers reachable from state/index.ts (e.g. the save-template dialog).
import { useActiveLanguageCode } from "../../l10n/useActiveContentLanguageCode.ts";
import { getScreenshotLanguageCodeQueryKey } from "./queryKeys.ts";

interface Options {
  nodeId: number;
}

export const useScreenshotUrl = ({ nodeId }: Options) => {
  const hostId = useContentHostId();
  const api = useThumbnailsApi();
  const queryClient = useQueryClient();

  const languageCode = useActiveLanguageCode();

  const { data: url = "" } = useQuery({
    queryKey: getScreenshotLanguageCodeQueryKey(hostId, nodeId, languageCode),
    queryFn: async () => {
      const result = await api.getThumbnail({
        hostId,
        nodeId,
        languageCode,
      });
      const existingUrl = queryClient.getQueryData<string>(
        getScreenshotLanguageCodeQueryKey(hostId, nodeId, languageCode),
      );
      if (existingUrl) {
        URL.revokeObjectURL(existingUrl);
      }
      if (!result) {
        return "";
      }
      return URL.createObjectURL(await (await fetch(result.url)).blob());
    },
  });

  return url;
};
